import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorCodeExpansionPanelModule } from '@portal-core/errors/components/error-code-expansion-panel/error-code-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { FlareTextEditorModule } from '@portal-core/project-files/components/flare-text-editor/flare-text-editor.module';
import { ProjectFilesTreeModule } from '@portal-core/project-files/components/project-files-tree/project-files-tree.module';
import { WorkspaceTreeModule } from '@portal-core/workspaces/directives/workspace-tree/workspace-tree.module';
import { ProjectFilesTreeItemPreviewComponent } from './project-files-tree-item-preview.component';

@NgModule({
  declarations: [
    ProjectFilesTreeItemPreviewComponent,
  ],
  imports: [
    CommonModule,
    ErrorCodeExpansionPanelModule,
    FlareTextEditorModule,
    LoaderModule,
    ProjectFilesTreeModule,
    WorkspaceTreeModule
  ],
  exports: [
    ProjectFilesTreeItemPreviewComponent
  ]
})
export class ProjectFilesTreeItemPreviewModule { }
